import React, { createContext, useCallback, useContext, useMemo, useState, useEffect } from 'react';

const SeoContext = createContext(null);

export function SeoProvider({ children }) {
  const [override, setOverride] = useState(null);

  const setPageSeo = useCallback((meta) => {
    setOverride(meta && typeof meta === 'object' ? meta : null);
  }, []);

  const clearPageSeo = useCallback(() => {
    setOverride(null);
  }, []);

  const value = useMemo(
    () => ({ override, setPageSeo, clearPageSeo }),
    [override, setPageSeo, clearPageSeo],
  );

  return <SeoContext.Provider value={value}>{children}</SeoContext.Provider>;
}

export function useSeoContext() {
  return useContext(SeoContext);
}

/**
 * Set page-level SEO override; cleared automatically on unmount or when deps change.
 */
export function usePageSeo(meta, deps = []) {
  const ctx = useSeoContext();
  const setPageSeo = ctx?.setPageSeo;
  const clearPageSeo = ctx?.clearPageSeo;

  useEffect(() => {
    if (!setPageSeo) return undefined;
    if (meta && typeof meta === 'object') {
      setPageSeo(meta);
    } else {
      clearPageSeo?.();
    }
    return () => clearPageSeo?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
